import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import NumberFormatCustom from "../../stateless/NumberFormatCustom";
import Transition from "../../stateless/Transition";
import styles from "../../../styles/global-styles";
import { AccesoryService } from "../../../services/accesory.service";
import ProviderSelect from "../../shared/selects/ProviderSelect";
import { validateEmptyValuesInForm } from "../../../_utils/utils";
import { ChipService } from "../../../services/chip.service";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  formControl: styles.globalFormControl,
}));

const EditAccesoryChip = ({
  productId,
  addAlert,
  detailAlert,
  onClose,
  open,
  updateAccesories,
  isChip,
}) => {
  const classes = useStyles();
  const [product, setProduct] = useState({});

  useEffect(() => {
    (async function () {
      try {
        if (isChip) {
          const { data } = await ChipService.getChipById(productId);
          console.log("get chip", data);
          const { cost, price, providerId } = data;
          setProduct({
            ...product,
            cost,
            price,
            providerId,
          });
        } else {
          const { data } = await AccesoryService.getAccesoryById(productId);
          console.log("get accesory", data);
          const { cost, price, discount, providerId } = data;
          setProduct({
            ...product,
            cost,
            price,
            discount,
            providerId,
          });
        }
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  const handleClose = () => {
    onClose("edit");
  };

  const handleSubmitForm = async () => {
    console.log("product", product);
    const validatedProduct = validateEmptyValuesInForm(product);
    let result;
    try {
      if (isChip) {
        const { status } = await ChipService.updateChip(
          productId,
          validatedProduct
        );
        result = status;
      } else {
        const { status } = await AccesoryService.updateAccesory(
          productId,
          validatedProduct
        );
        result = status;
      }
      if (result === 201) {
        updateAccesories(true, "Producto actualizado exitosamente");
      }
    } catch (error) {
      console.log("error UPDATE movile", error);
      updateAccesories(false, "Error al actualizar el producto");
    }
    onClose("edit");
  };

  const handleInputText = ({ target: { name, value } }) =>
    setProduct({ ...product, [name]: value });

  const handleProviderSelected = (option) =>
    setProduct({ ...product, providerId: option });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Editar producto
      </DialogTitle>
      <DialogContent>
        {Object.values(product).length > 0 && (
          <ValidatorForm
            noValidate
            className={classes.form}
            method="POST"
            onSubmit={handleSubmitForm}
            onError={(errors) => {}}
          >
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Costo
                  </Typography>
                  <TextValidator
                    name="cost"
                    value={product.cost}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  ></TextValidator>
                </Box>
              </Grid>
              <Grid item>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Precio
                  </Typography>
                  <TextValidator
                    name="price"
                    value={product.price}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  ></TextValidator>
                </Box>
              </Grid>

              {!isChip && (
                <Grid item>
                  <Box className={classes.box}>
                    <Typography
                      variant="body2"
                      component={"div"}
                      className={classes.label}
                    >
                      Descuento
                    </Typography>
                    <TextValidator
                      name="discount"
                      value={product.discount}
                      onChange={(e) => handleInputText(e)}
                      variant="outlined"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    ></TextValidator>
                  </Box>
                </Grid>
              )}
              <Grid item style={{ marginTop: 25 }}>
                <ProviderSelect
                  option={product.providerId}
                  title="Proveedor"
                  provider={handleProviderSelected}
                />
              </Grid>

              <Grid
                style={{ marginTop: 40 }}
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <Grid item>
                  <Button
                    color="primary"
                    style={{ marginRight: 50, width: 150 }}
                    onClick={handleClose}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </ValidatorForm>
        )}
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(EditAccesoryChip);
